import React from "react";
import { Alert, Button, Container, Form } from "react-bootstrap";
import { HomeProps } from "../types/appTypes";

export default class Layout extends React.Component<HomeProps, {}> {
	constructor(props: HomeProps) {
		super(props);
		this.state = {};
	}

	render(): React.ReactNode {
		return (
			<Container>
				{process.env.REACT_APP_INTEGRATION_SERVICE === "BitBucket" && (
					<Alert show={true} variant="warning" className="m-3">
						<Alert.Heading> Warning </Alert.Heading>
						<p style={{ maxWidth: "fit-content" }}>
							You won't be able to log-in if you haven't installed the application on BitBucket.
						</p>
					</Alert>
				)}
				<div className="m-3 row justify-content-center">
					<Button href={this.props.oauthUrl}>Log in with {process.env.REACT_APP_INTEGRATION_SERVICE}</Button>
				</div>
				<Form.Text id="knowledgeBaseLink" className="m-3" muted>
					To know more about this add-in, please,{" "}
					{process.env.REACT_APP_INTEGRATION_SERVICE === "GitHub" && (
						<a
							rel="noreferrer"
							href="https://knowledgebase.businessmap.io/hc/en-us/articles/8621559080082-Businessmap-Integration-with-GitHub-bi-directional"
							target="_blank"
						>
							click here
						</a>
					)}
					{process.env.REACT_APP_INTEGRATION_SERVICE === "GitLab" && (
						<a
							rel="noreferrer"
							href="https://knowledgebase.businessmap.io/hc/en-us/articles/12687248770706-Businessmap-Integration-with-GitLab-bi-directional"
							target="_blank"
						>
							click here
						</a>
					)}
				</Form.Text>
				<Alert show={true} variant="warning" className="m-3">
					<Alert.Heading> Notice </Alert.Heading>
					<p style={{ maxWidth: "fit-content" }}>
						By using this application, you agree to the following{" "}
						<a rel="noreferrer" href="https://businessmap.io/terms-of-use" target="_blank">
							terms and conditions
						</a>
						. If you do not agree, do not use this application.
					</p>
				</Alert>
			</Container>
		);
	}
}
